export default __webpack_public_path__ + "static/media/ico-sq-4-education.6ff9b416.svg";